import { render, staticRenderFns } from "./DistributionListEdit.vue?vue&type=template&id=40df0f6d&scoped=true&"
import script from "./DistributionListEdit.vue?vue&type=script&lang=js&"
export * from "./DistributionListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df0f6d",
  null
  
)

export default component.exports